import { styled } from "@mui/material/styles";

export const Component = styled("div", {
  label: "offer-bc-layout-content",
})`
  background: ${({ theme }) => theme.palette.color.gray[100]};
  padding: 0;
  position: relative;
`;

export const Header = styled("header", { label: "header" })`
  color: ${({ theme }) => theme.palette.color.primary.main};

  ${({ theme }) => theme.breakpoints.up("md")} {
    display: flex;
    align-items: baseline;
    margin-bottom: ${({ theme }) => theme.spacing(1.5)};
    background-color: initial;
  }
`;

export const TitleWrapper = styled("div", { label: "title-wrapper" })`
  text-align: center;
  flex: auto;
`;

export const Title = styled("h1", { label: "title" })`
  font-size: 18px;
  font-weight: 500;

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 32px;
    font-weight: 500;
    text-align: left;
  }
`;

export const Subtitle = styled("span", { label: "subtitle" })`
  color: ${({ theme }) => theme.palette.color.text.primary};
  font-size: 18px;
  font-weight: 400;

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 24px;
    font-weight: 400;
  }
`;
